module.exports = __webpack_public_path__ + "img/consultInd.3b67008d.png";